export const QA_NAME_COPIED_TO_TAG_ITEM = 'copiedToTag'
